export interface ValueLine {
  label: string
  value: string
}
/** Where the "$704 real value" comes from — shown in the offer and summary blocks. */
export const valueStack: ValueLine[] = [
  { label: 'Plan semestru (16 tygodni, 3 ścieżki)', value: '$47' },
  { label: '6 kompletnych tomów dydaktycznych', value: '$407' },
  { label: '5 darmowych bonusów (5 × $50)', value: '$250' },
]
export const TOTAL_VALUE = '$704'
export const PRICE = '$35'
export const SAVINGS = '$669'
export const PRICE_PLN = 'ok. 130 zł'
export const CURRENCY_NOTE = 'Płacisz w USD — Twój bank automatycznie przeliczy kwotę na złote.'
